import type { VV } from '@semios/app-platform-value-type-definitions'
import { isNil } from 'lodash'
import moment from 'moment-timezone'
import type { ImperialXorMetric } from 'stores/fieldAssetStore/fieldAssetStore'
import { convertPressureFromPSIToKPa } from '../../_utils/convertPressureFromPSIToKPa'
import type { TSplineSeriesData } from '../../types'

export const processPressureData = (
  pressureDataMap: Record<
    string,
    NonNullable<NonNullable<VV.Response['points']>[string]['values']['irrigationPressureSemios_pump']>
  >,
  pointLngLat: string,
  showPressure: boolean,
  pressureUnitFromUserSetting: ImperialXorMetric,
  timezone: string,
): TSplineSeriesData[] => {
  if (!showPressure) return []

  return (pressureDataMap[pointLngLat] ?? []).flatMap((p) =>
    p?.timeseries
      ? (p.timeseries ?? []).map((d) => {
          const average = d.value?.average

          const value = average
            ? convertPressureFromPSIToKPa({
                desiredUnitIMPERIALxorMETRIC: pressureUnitFromUserSetting,
                psiAmount: average,
              })
            : average

          return {
            x: moment.tz(d.timestamp, timezone).valueOf(),
            y: isNil(average) ? undefined : Number(value),
          }
        })
      : [],
  )
}
